import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AppLogo from "./AppLogo";
import AppContext from "../AppContext";
import { gapi } from "gapi-script";
import msalInstance, { Role } from "../Constants";

function Layout({ children }) {
  const navLinks = [
    { name: "Dashboard", href: "/", soon: false, current: true },
    { name: "Analytics", soon: true, current: false },
  ];
  const navigate = useNavigate();
  const authCtx = useContext(AppContext);
  const [navigation, setNavigation] = useState(navLinks);
  const [isOpen, setIsOpen] = useState(false);

  const onClickLogo = () => {
    navigate(`/`);
  };

  const onLogoutClick = () => {
    handleGoogleLogout();
    msalInstance.logout();
    authCtx.logout();
    navigate("/");
    setIsOpen(false);
  };
  function handleGoogleLogout() {
    gapi.auth2
      ?.getAuthInstance()
      ?.signOut()
      .then(() => {
        console.log("User signed out successfully.");
        // Perform additional actions after sign-out if needed
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  }
  const onNavigate = (d) => {
    if (d.href) {
      navigate(d.href);
      setNavigation((pre) =>
        pre.map((x) =>
          x.name === d.name ? { ...x, current: true } : { ...x, current: false }
        )
      );
    }
  };
  const toggleStream = () => {
    authCtx.setShowStream(!authCtx.showStream);
  };
  return (
    <div className="w-full min-h-screen bg-neutral-950 overflow-hidden z-20">
      <div className="px-7 flex justify-between shadow-sm shadow-slate-600 items-center w-full h-14">
        <div className="flex gap-3 items-center">
          <button
            type="button"
            className="h-9 pr-1 gap-3 flex items-center cursor-pointer"
            onClick={onClickLogo}
          >
            <img
              src="GamberaDynamicsLogo.svg"
              className="w-24 lg:w-28"
              alt="gd-rms_logo"
            />
            <div className="text-white font-semibold text-xl">
              | VISION AI: INTELLIGENT VIDEO SOLUTION
            </div>
            {/* <img src="Nav_logo.png" alt="LOGO" className="h-9" /> */}
          </button>
        </div>
        <div className="flex pl-7 gap-2 text-neutral-700">
          {/* <button
            className="text-white bg-gray-600 rounded-md my-1 px-3 hover:bg-gray-500"
            onClick={toggleStream}
          >
            {authCtx.showStream ? "Show Video" : "WEB CAM"}
          </button> */}
          {navigation.map((x, index) => (
            <button
              onClick={() => onNavigate(x)}
              key={index}
              className={`${
                x.current
                  ? "text-white border-b-4 border-white"
                  : "text-neutral-500"
              } h-full flex items-center gap-1 my-auto px-3 py-3 text-sm font-medium `}
            >
              {x.name}
            </button>
          ))}
          <div className="relative dropdown dropdown-end mt-2 z-50">
            <div className="relative">
              <button onClick={() => setIsOpen(!isOpen)}>
                <div
                  className="btn bg-inherit border-none hover:bg-inherit"
                  tabIndex="0"
                >
                  <img
                    src="profile-user.svg"
                    alt="propic"
                    className="h-8 w-8"
                  />
                </div>
              </button>

              {isOpen && (
                <div
                  tabindex="0"
                  className="dropdown-content absolute right-0 dropDownProfile menu pt-1 outline outline-1 outline-white bg-neutral-950 text-white rounded-lg shadow border dark:border-transparent mt-2"
                >
                  <ul className="dark:text-white space-y-3">
                    <div className="flex px-5 gap-3 justify-start">
                      <div className="flex w-12 justify-center items-center">
                        <img
                          src="profile-user.svg"
                          alt="propic"
                          className="h-12 w-12"
                        />
                      </div>
                      <div className="flex flex-col w-fit gap-1">
                        <label className="font-bold text-sm truncate">
                          {authCtx.profile?.name}
                        </label>
                        <label className=" font-normal text-xs">
                          {authCtx.profile?.email}
                        </label>
                        <label className="font-semibold role-gradient text-xs ">
                          {
                            Role.find((u) => u.value === authCtx.profile?.role)
                              ?.label
                          }
                        </label>
                      </div>
                    </div>
                    <div className="flex border-t border-stone-500 justify-start font-medium">
                      {authCtx.profile?.role !== 300 && (
                        <button
                          type="button"
                          className="inline-flex px-5 py-2 border-r border-stone-500 h-full w-1/2 relative items-center text-sm font-medium text-center"
                          onClick={() => setIsOpen(false)}
                        >
                          <Link
                            to="/settings"
                            className="inline-flex items-center text-sm font-medium text-center"
                          >
                            <div className="mr-3">
                              <img
                                src="settings-icon.svg"
                                alt="settings"
                                className="invert"
                              />
                            </div>
                            <div className="text-xs">Settings</div>
                          </Link>
                        </button>
                      )}
                      <div
                        className={`${
                          authCtx.profile?.role === 300
                            ? " w-full justify-end px-3"
                            : " w-1/2 justify-end px-5"
                        } flex py-2 font-medium`}
                      >
                        <button
                          type="button"
                          onClick={onLogoutClick}
                          className="flex gap-2 items-center text-orange-600 transform transition-colors duration-200 border-r-4 border-transparent justify-center"
                        >
                          <label className="text-xs">Logout</label>
                          <div className="mr-3">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 1H11.6667C12.0203 1 12.3594 1.14048 12.6095 1.39052C12.8595 1.64057 13 1.97971 13 2.33333V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H9"
                                stroke="#F45208"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.66699 10.3332L9.00033 6.99984L5.66699 3.6665"
                                stroke="#F45208"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9 7H1"
                                stroke="#F45208"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>
                    </div>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="h-full w-screen overflow-x-hidden ">{children}</div>
    </div>
  );
}

export default Layout;
